import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { hasClass, letsGetStickyWithIt } from "../lib/utils";

/**
 * StickyContainer
 */
class StickyContainer extends Component {
  static propTypes = {
    windowScrollY: PropTypes.number.isRequired,
    mountElementId: PropTypes.string,
    children: PropTypes.node,
    portal: PropTypes.bool
  };

  static defaultProps = {
    children: null,
    mountElementId: null,
    portal: false
  };

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
  }

  state = {
    isFixed: false,
    left: 0,
    width: 0,
    top: 0
  };

  componentWillMount() {
    this.MOUNT_NODE = document.getElementById(this.props.mountElementId);
    if (this.MOUNT_NODE && this.props.windowScrollY) {
      this.setState({
        isFixed: this.props.windowScrollY >= this.MOUNT_NODE.offsetTop - 20,
        left: this.MOUNT_NODE.offsetLeft,
        width: this.MOUNT_NODE.offsetWidth
      });
    }
  }

  componentDidMount() {
    // window.fireEvent('letsgetstickywithit', {
    //
    // });
    if (hasClass("ie-lte-9")) {
      letsGetStickyWithIt(this.containerRef.current.innerRef);
    }
  }

  componentWillReceiveProps(props) {
    if (this.MOUNT_NODE && this.props.windowScrollY !== props.windowScrollY) {
      this.setState({
        isFixed: props.windowScrollY >= this.MOUNT_NODE.offsetTop - 20,
        left: this.MOUNT_NODE.offsetLeft,
        width: this.MOUNT_NODE.offsetWidth
      });
    }
  }

  render() {
    const style = this.state.isFixed
      ? {
          position: "fixed",
          left: this.state.left,
          width: this.state.width,
          top: this.state.top
        }
      : {};

    const view = (
      <div
        style={style}
        className={`StickyContainer ${this.state.isFixed ? "StickyContainer--fixed" : ""}`}
        ref={this.containerRef}
      >
        {this.props.children}
      </div>
    );

    if (this.props.portal && this.MOUNT_NODE) {
      return ReactDOM.createPortal(view, this.MOUNT_NODE);
    }
    return view;
  }
}

export default connect(state => ({
  windowScrollY: state.app.get("windowScrollY")
}))(StickyContainer);
